import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VersionComponent {

  public appVersion = environment.version;
  public commitHash = environment.commitHash;

}
